import React, {useEffect, useState} from 'react'
import clinicService from '../../../../../services/clinic.service'
import Loading from '../../../../common/Loading'
import CustomizationForm from './CustomizationForm'
import {useParams} from 'react-router-dom'

function CustomizationTab() {

    const {clinicId} = useParams();
    const [customization, setCustomization] = useState([])
    const [loading, setLoading] = useState(false)
    const [isEditing, setIsEditing] = useState(false)

    useEffect(() => {
        setLoading(true)
        clinicService.getCustomization(clinicId)
            .then(res => {
                setLoading(false)
                console.log(res.data)
                setCustomization(res.data)
            })
            .catch(err => {
                setLoading(false)
                console.log("Error")
            })
    }, [])

    const updateCustomization = (customValue) => {
        // console.log("update Customizaion")
        setCustomization(customValue)
    }
    return (
        <>
            <div className="card-padding card-body">
                <div className='d-flex justify-content-between'>
                    <div className="card-title"><i className="bi bi-house-gear"></i> Clinic Customization</div>
                    <div>
                        {isEditing ?
                            <button className="btn btn-outline-danger btn-sm mt-2" onClick={() => setIsEditing(false)}>
                                <i className="bi bi-x-square bi-sm"></i> Cancel
                            </button>
                            :
                            <button className="btn btn-outline-primary btn-sm mt-2" onClick={() => setIsEditing(true)}>
                                <i className="bi bi-pencil-square bi-sm"></i> Modify
                            </button>
                        }
                    </div>
                </div>
            </div>
            <div className='row ms-2'>
                {loading ? <Loading/> :
                    isEditing ?
                        <CustomizationForm customization={customization} updateCustomization={updateCustomization}/> :
                        <>
                            <div className="card-padding card-body">
                                <table className="table table-bordered table-hover table-striped">
                                    <thead>
                                    <tr>
                                        <th className="col-4"><i className="bi bi-key"></i> Key</th>
                                        <th className="col-8"><i className="bi bi-receipt"></i> Value</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        customization.length > 0 ? (
                                            customization.map((item) => {
                                                return <tr key={item.id}>
                                                    <td>{item.optionKey}</td>
                                                    <td>{item.optionValue}</td>
                                                </tr>
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="2">
                                                    <div className="alert alert-danger mb-0" role="alert">
                                                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                                                        Error: No customization values found!
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </>
                }
            </div>

        </>
    )
}

export default CustomizationTab